import MaintenanceScheduleYears from "./formQuestions/maintenanceScheduleYears.vue";
import MaintenanceScheduleModel from "./formQuestions/maintenanceScheduleModel.vue";
import MaintenanceScheduleTrim from "./formQuestions/maintenanceScheduleTrim.vue";
import MaintenanceScheduleMileage from "./formQuestions/maintenanceScheduleMileage.vue";
class Questions {
}
Questions.year = {
    number: 1,
    title: "What Year Is Your Subaru?",
    answers: MaintenanceScheduleYears,
};
Questions.model = {
    number: 2,
    title: "Which Subaru Do You Own?",
    answers: MaintenanceScheduleModel,
};
Questions.trim = {
    number: 3,
    title: "Which Trim Level Is Your Subaru?",
    answers: MaintenanceScheduleTrim,
};
Questions.mileage = {
    number: 4,
    title: "What Is The Estimated Mileage On Your Subaru?",
    answers: MaintenanceScheduleMileage,
};
export default Questions;
